import { render, staticRenderFns } from "./ValueKpi.vue?vue&type=template&id=71f9d0b4"
import script from "./ValueKpi.vue?vue&type=script&lang=js"
export * from "./ValueKpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VResponsive,VRow})


/* hot reload */
if (module.hot) {
  var api = require("G:\\Azure-Agent\\_work\\25\\s\\packages\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f9d0b4')) {
      api.createRecord('71f9d0b4', component.options)
    } else {
      api.reload('71f9d0b4', component.options)
    }
    module.hot.accept("./ValueKpi.vue?vue&type=template&id=71f9d0b4", function () {
      api.rerender('71f9d0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GeneralReporting/Statistics/ValueKpi.vue"
export default component.exports